import React from 'react';
import triangleAlertIcon from '../../../../../../assets/icons/icon_alert_yellow_triangle.svg';
import { NOTIFICATION_PENDING_UPDATE } from '../../data';
import styles from './NotificationPendingUpdate.module.scss';

export const NotificationPendingUpdate = () => {
    return (
        <div className={styles.container}>
            <img src={triangleAlertIcon} alt="" />
            <div>
                <p className={styles['bold-text']}>{NOTIFICATION_PENDING_UPDATE.title}</p>
                <p className={styles['regular-text']}>{NOTIFICATION_PENDING_UPDATE.description}</p>
            </div>
        </div>
    )
}
